"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Radium = require("radium");
var omit = require("lodash.omit");
var react_1 = require("react");
var components_1 = require("components");
var CardBody_1 = require("components/Card/CardBody");
var CardImage_1 = require("components/Card/CardImage");
var CardTitle_1 = require("components/Card/CardTitle");
var styles_1 = require("styles");
var componentStyle = {
    base: {
        borderRadius: '4px',
        ':hover': styles_1.elevation['2'],
    },
};
var Card = (function (_super) {
    __extends(Card, _super);
    function Card() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Card.prototype.render = function () {
        var _a = omit(this.props, ['elevation']), children = _a.children, image = _a.image, style = _a.style, otherProps = __rest(_a, ["children", "image", "style"]);
        return (React.createElement(components_1.Paper, __assign({ style: [componentStyle.base, style] }, otherProps),
            !!image && React.createElement(CardImage_1.CardImage, { url: this.props.image }),
            this.renderTitle(),
            React.createElement(CardBody_1.CardBody, null, children)));
    };
    Card.prototype.renderTitle = function () {
        var _a = this.props, title = _a.title, color = _a.color;
        if (!title) {
            return null;
        }
        var fontColor = color ? styles_1.FontColor.White : styles_1.FontColor.Gray;
        return React.createElement(CardTitle_1.CardTitle, { fontColor: fontColor, bgColor: color }, title);
    };
    Card = __decorate([
        Radium
    ], Card);
    return Card;
}(react_1.PureComponent));
exports.Card = Card;



//////////////////
// WEBPACK FOOTER
// ./src/components/Card/Card.tsx
// module id = 282
// module chunks = 0